import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {
  connect() {
    this.toast = new Toast(this.element, { autohide: false })
  }

  show() {
    if (!this.toast.isShown()) {
      this.toast.show()
    }
  }

  hide() {
    if (this.toast.isShown()) {
      this.toast.hide()
    }
  }
}
